import { useState } from "react";
import { IconButton } from "../../components";
import { FiltersAppliedWarningMessage, Main, PageSubHeader, ThemedIcon, ThemedSpan } from "../../components/utilities";
import Dropdown from "../../components/utilities/Dropdown";
import { useFilterContext } from "../../hooks/FilterContext";
import HubwiseFileUploadModal from "./components/HubwiseFileUploadModal";
import HubwiseJobsFilterModal from "./components/HubwiseJobsFilterModal";
import HubwiseJobsTable from "./components/HubwiseJobsTable";

const HubwiseManagement = () => {

    const { clearFilter, isFiltersApplied } = useFilterContext();
    const [isFiltersShown, setIsFiltersShown] = useState(false);
    const [isUploadShown, setIsUploadShown] = useState(false);

    return (
        <>
            <Main className="d-flex flex-column">
                <PageSubHeader>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex flex-column ps-3">
                            {isFiltersApplied && (
                                <span className="d-flex mb-2">
                                    <ThemedIcon className="my-auto" icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                    <FiltersAppliedWarningMessage className="ms-2 text-muted">
                                        Warning - Filters are currently being applied to your results.
                                        <br />
                                        <button className="anchor" onClick={clearFilter}>Click here</button> to clear your filters.
                                    </FiltersAppliedWarningMessage>
                                </span>
                            )}
                            <ThemedSpan variant="danger" className="fs-small">Hover a stage's status icon to view details/warnings</ThemedSpan>
                        </div>
                        <div className="d-flex flex-row-reverse">
                            <IconButton
                                className="mt-auto"
                                icon={['fas', 'filter']}
                                onClick={() => setIsFiltersShown(true)}
                                menu={[
                                    <Dropdown.Menu>
                                        <Dropdown.MenuItem
                                            icon={(['fas', 'plus'])}
                                            text="Upload Files"
                                            onClick={() => setIsUploadShown(true)}
                                        />
                                    </Dropdown.Menu>
                                ]}
                            >
                                Filter Jobs
                            </IconButton>
                        </div>
                    </div>
                </PageSubHeader>
                <section className="px-4 my-3 h-100">
                    <HubwiseJobsTable />
                </section>
            </Main>
            <HubwiseFileUploadModal
                show={isUploadShown}
                onHide={() => setIsUploadShown(false)}
            />
            <HubwiseJobsFilterModal
                show={isFiltersShown}
                onHide={() => setIsFiltersShown(false)}
            />
        </>
    )
}

export default HubwiseManagement;